/**
 * This constant provide an initial values
 * to totals component.
 */
export const initTotals = {
    downPaymentPercentage: 0,
    duration: 0,
    durationId: 0,
    model: '',
    modelId: 0,
    year: '',
    version: '',
    versionId: 0,
    legalTerms: '',
    retailPrice: 0,
    installmentAmount: 0,
    productId: 0,
    productName: '',
    totalHitch: 0,
};

/**
 * This constant is the custom class for the legal tooltip
 * used in totals component.
 */
export const customClassModifierToTooltip = 'c-tooltip-porsche';
